export default [
  {
    name: 'archives',
    path: '/archives',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Arquivos',
      icon: 'dvr',
      label: 'Arquivos',
      permission: 'archive.list'
    }
  },
  {
    name: 'archive-edit',
    path: '/archives/edit/:id',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Arquivo - Edição',
      icon: 'dvr',
      label: 'Arquivo - Edição',
      permission: 'archive.edit'
    }
  },
  {
    name: 'archive-new',
    path: '/archives/new',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Arquivo - Adicionar',
      icon: 'dvr',
      label: 'Arquivo - Adicionar',
      permission: 'archive.add'
    }
  }
]
